import { render, staticRenderFns } from "./light.vue?vue&type=template&id=31fecf29"
import script from "./light.vue?vue&type=script&lang=js"
export * from "./light.vue?vue&type=script&lang=js"
import style0 from "./light.vue?vue&type=style&index=0&id=31fecf29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports